import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  getContractInvoiceList,
  updateContractInvoiceStatus,
} from "libs/api/contract_invoice";

export const getContractInvoiceListThunk = createAsyncThunk(
  "contractInvoice/getAll",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, queryParams } = {}) => {
    try {
      typeof cbPending === "function" && cbPending();
      const res = await getContractInvoiceList(queryParams);
      typeof cbFulfilled === "function" && cbFulfilled(res?.data);
      return res?.data;
    } catch (error) {
      const err = error.response ? error.response.data : { message: error.message };
      typeof cbRejected === "function" && cbRejected(err);
      throw JSON.stringify(err);
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  },
);

export const updateContractInvoiceStatusThunk = createAsyncThunk(
  "contractInvoice/updateStatus",
  async ({ cbPending, cbFulfilled, cbRejected, cbFinally, id, body } = {}) => {
    try {
      typeof cbPending === "function" && cbPending();
      const res = await updateContractInvoiceStatus(id, body);
      typeof cbFulfilled === "function" && cbFulfilled(res?.data);
      return res?.data;
    } catch (error) {
      const err = error.response ? error.response.data : { message: error.message };
      typeof cbRejected === "function" && cbRejected(err);
      throw JSON.stringify(err);
    } finally {
      typeof cbFinally === "function" && cbFinally();
    }
  },
);
